import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { Network } from '@ionic-native/network/ngx';
import { SuperTabsModule } from '@ionic-super-tabs/angular';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from './src/components/components.module';
import { SharedComponentsModule } from './src/components/sharedComponents.module';
import { DownloadModule } from './src/modules/download/download.module';
import { FilesystemModule } from './src/modules/filesystem/filesystem.module';
import { GuidModule } from './src/modules/guid/guid.module';
import { LoggerModule } from './src/modules/logger/logger.module';
import { StoreModule } from './src/modules/store/store.module';
import { UnzipModule } from './src/modules/unzip/unzip.module';
import { VersionsModule } from './src/modules/versions/versions.module';
import { InjectorService, OrchestratorService } from './src/services/security';
import { ServiceModule } from './src/services/security/services.module';
import { PipeModule } from 'apps/idl/src/pipes';

const importModules: (Type<any> | ModuleWithProviders<any>)[] = [
	IonicModule,
	CommonModule,
	FormsModule,
	ReactiveFormsModule,
	ServiceModule,
	PipeModule,
	ComponentsModule,
	HttpClientModule,
	SuperTabsModule.forRoot(),
	DownloadModule,
	UnzipModule,
	VersionsModule,
	GuidModule,
	StoreModule,
	FilesystemModule
];
const exportModules: Type<any>[] = [
	ComponentsModule,
	ServiceModule,
	PipeModule,
	SharedComponentsModule,
	LoggerModule
];
const providers: Provider[] = [
	Network,
	FileOpener,
	FileTransfer,
	HttpClient
];

@NgModule({
	imports: importModules,
	exports: exportModules,
	providers: [
		providers
	]
})
export class OsappModule {

	constructor(
		psvcOrchestrator: OrchestratorService,
		//A CONSERVER : Nécessaire à l'initialisation du singleton
		psvcInjector: InjectorService
	) {
		psvcOrchestrator.init();
	}

}
